<!-- eslint-disable prettier/prettier -->
<template>
  <div class="DetailCont-container ut-flex">
    <div v-if="this.version" class="gb-wrap my-wrap clearfix">
      <div class="my-slogan">我在木夕发现了一部超好看的作品，推荐给你！</div>
      <div class="my-left ut-fl">
        <div class="my-engine">
          <div class="engine-wrapper">
            <iframe id="engineIfr" class="my-engine-ifr" frameborder="0" :src="engineSrc"></iframe>
          </div>
        </div>
      </div>
      <div class="my-right ut-fl">
        <div v-if="isViewReady" class="my-rightwrap">
          <div class="my-title">
            {{ viewData.name }}
            <em>{{ viewData.status }}</em>
          </div>
          <p class="my-inforow">
            <b>作者：</b>
            {{ viewData.author }}
          </p>
          <p class="my-inforow">{{ cp_desc }}</p>
          <ul class="my-taglist clearfix">
            <li v-for="(item, index) in viewData.labels" :key="index">{{ item }}</li>
          </ul>
          <pre class="my-brief"><b>简介：</b>{{viewData.summary}}</pre>
        </div>
        <BaseQrcodeGroup class="my-qrcodegroup" />
      </div>
    </div>
    <div v-if="isInvlid" class="gb-wrap my-invalid ut-flex-center">该作品未过审或已删除下架！</div>
  </div>
</template>

<script>
/* eslint-disable no-empty */
/* eslint-disable prettier/prettier */
import { mapGetters, mapMutations, mapState } from 'vuex'

import BaseQrcodeGroup from '@/components/BaseQrcodeGroup'

export default {
  name: 'DetailCont',
  components: {
    BaseQrcodeGroup,
  },
  data() {
    return {
      isDetailReady: false,
      engineSrc: '',
      DICT: {
        check_level: {
          //【作品运营状态】包括：待审核、未过审、过审、优品、精选、已下架
          '-4': '未发布',
          '-3': '调试debug',
          '-2': '已下架',
          '-1': '未过审',
          0: '未审核',
          1: '待审核',
          2: '过审',
          3: '优品',
          4: '精选',
        },
        complete_flag: {
          //【作品状态】包括：连载中，完结，精修中，部分完结
          0: '未完结',
          1: '完结',
          2: '连载中',
          3: '精修中',
          4: '待上映',
        },
      },
      gindex: '',
      version: '',
      pageDetail: {},
      viewData: {},
      isInvlid: false, // 当前作品是否无效
    }
  },
  computed: {
    ...mapState(['vx_userInfo', 'vx_loginTimestamp']),
    ...mapGetters(['vx_get_token']),
    cp_desc() {
      let data = this.viewData
      if (data.textNum == undefined) return ''
      let str = data.textNum + '字 / '
      if (data.endingNum) str += `${data.endingNum}个结局 / `
      if (data.auditStateCode != 2) str += data.auditState + ' / ' //过审状态则不显示“过审”二字
      str += data.status
      return str
    },
    isThumbsGiven() {
      return !!(this.pageDetail.is_praise * 1)
    },
    isFocused() {
      return !!(this.pageDetail.is_follow * 1)
    },
    isFavored() {
      return !!(this.pageDetail.is_fav * 1)
    },
    isViewReady() {
      // return !_.isEmpty(this.viewData)
      return this.viewData.name // 未过审作品接口返回的数据为作品名等字段皆为null
    },
  },
  watch: {
    vx_loginTimestamp(v) {
      console.log('vx_loginTimestamp =====> ', v)
      this.init()
    },
    isFocused(v) {
      try {
        window.$website.postMessage('setFollow', v)
      } catch (e) {}
    },
    isFavored(v) {
      try {
        window.$website.postMessage('setFavor', v)
      } catch (e) {}
    },
    isThumbsGiven(v) {
      try {
        window.$website.postMessage('setLike', v)
      } catch (e) {}
    },
  },
  created() {
    this.init()
    this.setEngineMethods()
    window.addEventListener('message', this.fn_messageListener)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.fn_messageListener)
  },
  methods: {
    ...mapMutations(['vx_toggleLogin', 'vx_setUserInfo']),
    async init() {
      this.gindex = this.$route.params.gindex * 1 || this.$utils.getURLParam('gindex')
      // this.version = this.$utils.getURLParam('version')
      let res = await this.$api.getVersion({ gindex: this.gindex })
      this.version = res.data
      if (!this.version) {
        this.isInvlid = true
        return
      }
      this.isInvlid = false
      this.$api
        .getPageDetail({
          gindex: this.gindex,
          version: this.version,
        })
        .then((res) => {
          if (res.isOk) {
            this.isDetailReady = true
            this.setPageDetail(res.data)
          }
        })

      this.$nextTick(() => {
        if (!window.cgAdJsBridge) return
        let adConfig = {
          $videoWrap: document.querySelector('.engine-wrapper'),
          $engine: document.getElementById('engineIfr'),
          appVersion: 'MuccyBook',
          // 木夕后台生成的必要字段
          appId: 'DHODF4ZG',
          appSecret: '3215eb4c68d0f9b50208eef4e704954cf991158f',
          publicKey: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC6sUm6yKTWwQ3YQq4CnYjXKSwerTJaB3o3xwiu5Hqwi/QrhKe1ROfVNMBqdZGbWOGyB5ImDRJnlXJm89ZjDenOYrCzcottPOdtGHiHSDEjaOvv/GxA6aB9kLyMobT/dWkKAiBSukK4tif4+BqpXVMYPKVbczzfgWtvnej3XIDmzwIDAQAB',
          // 获取广告时用的平台参数
          platformName: 'web',
          report: {
            gindex: this.gindex,
            uid: this.vx_userInfo? this.vx_userInfo.uid: '',
            platformName: 'Web'
          },
        }

        window.cgAdJsBridge(adConfig)
      })

      this.setEngineSrc(true)
    },
    setPageDetail(data) {
      this.pageDetail = Object.assign({}, this.pageDetail, data)
      this.setViewData()
    },
    setViewData() {
      let data = this.pageDetail
      if (_.isEmpty(data)) return
      this.viewData = {
        name: data.gname,
        author: data.nickname,
        labels: (data.tag_list || []).map((d) => d.tname),
        status: this.DICT['complete_flag'][data.complete_flag] || '未知',
        textNum: data.word_sum,
        endingNum: data.game_node * 1,
        auditStateCode: data.check_level,
        auditState: this.DICT['check_level'][data.check_level] || '未知',
        summary: data.description_short,
      }
    },
    setEngineSrc(refresh = false) {
      //-- 加载引擎URL
      let prefix = ''
      let { isDev, isTest, isDebug } = this.$utils
      if (isDev() || isTest()) prefix = 'test-'
      else if (isDebug()) prefix = 'debug-'
      // TODO:引擎测试环境有问题，暂时用正式环境进行开发
      // if (isDev()) prefix = ''
      let host = `//${prefix}mx.muccybook.com`
      let gindex = `w_index=${this.gindex}`
      let version = this.version ? '&w_ver=' + this.version : ''
      // let plat = '&plat=m_preview'
      this.engineSrc =
        host +
        `/engine/preview.html?${gindex}${version}&v=${
          refresh ? Date.now() : Math.floor(Date.now() / (60 * 1000))
        }`
    },
    showDownloadTip() {
      this.$toast('请扫码进入小程序或下载App体验更多功能')
    },
    setEngineMethods() {
      //定义引擎所需调用方法
      window.$website = Object.assign({}, window.$website, {
        toLogin: () => this.vx_toggleLogin(true),
        //显示结局卡片分享
        openEndingCardShare: null,
        //评论
        openComments: null,
        //打赏
        openReward: null,
        openLike: null,
        setFollow: (reverse = !this.isFocused) => {
          if (!this.vx_get_token) return this.vx_toggleLogin(true)
          let fn = reverse ? 'followAuthor' : 'cancelFollowAuthor'
          this.$api[fn]({
            gindex: this.gindex,
            version: this.version,
            authorUid: this.pageDetail.author_uid,
            tid: this.pageDetail.tid,
          }).then((res) => {
            if (res.message && res.message.code == '2000') {
              this.setPageDetail({
                is_follow: reverse * 1,
              })
              let words = reverse ? '已关注' : '取消关注'
              this.$toast(words)
            } else this.$toast('关注失败')
          })
        },
        setFavor: (reverse = !this.isFavored) => {
          if (!this.vx_get_token) return this.vx_toggleLogin(true)
          let fn = reverse ? 'setCollection' : 'cancelCollection'
          this.$api[fn]({
            gindex: this.gindex,
            version: this.version,
            tid: this.pageDetail.tid,
          }).then((res) => {
            if (res.message && res.message.code == '2000') {
              this.setPageDetail({
                fav_num: this.pageDetail.fav_num * 1 + (reverse ? 1 : -1),
                is_fav: reverse * 1,
              })
              let words = reverse ? '已收藏' : '取消收藏'
              this.$toast(words)
            } else {
              let words =
                res.message.message && res.message.message != 'Undefined'
                  ? res.message.message
                  : '收藏失败'
              this.$toast(words)
            }
          })
        },
        getNetworkType: () => {
          let networkType = this.$utils.getNetworkType() || 'wifi'
          window.$website.postMessage('setNetworkType', networkType)
        },
        getInitData: () => ({
          isLiked: this.isThumbsGiven,
          isFollowed: this.isFocused,
          isFavored: this.isFavored,
        }),
        toggleBgm: null,
        openBuyOption: (params) => {
          // if (this.$utils.isDev()) params = params || {
          //   // token: '',
          //   // opusId: '',
          //   title: '男主线',
          //   s_id: 'WebKitFormBoundaryBqfHzGNxJaQSsABK',
          //   i_id: '64b28fc911af9376',
          //   type: '1',
          //   num: '20'
          // }
          console.log('this.$utils.isDev() ========> ', this.$utils.isDev())
          this.doBuyOption(params)
        },
        openBuyTime: null,
        openShare: null,
        __engineReadyCount: 0,
        engineReady: (callback) => {
          console.log('================> engineReady!!')
          if (!this.isDetailReady && !this.vx_userInfo && this.__engineReadyCount++ < 100)
            return setTimeout(() => window.$website.engineReady(), 300)
          let userInfo = this.vx_userInfo || {}
          try {
            let $website = window.$website
            let token = this.vx_get_token
            let gindex = this.gindex
            let user_uid = userInfo.uid
            let user_nickname = userInfo.nickName
            let detail_name = this.pageDetail.gname
            $website.postMessage('setWorkInfo', {
              w_index: gindex,
              w_name: detail_name,
            })
            $website.postMessage('setUserInfo', {
              uid: user_uid,
              uname: user_nickname,
              token,
            })
            $website.postMessage('setFollow', this.isFocused)
            $website.postMessage('setFavor', this.isFavored)
            $website.postMessage('setLike', this.isThumbsGiven)

            if (typeof callback == 'function') callback()
          } catch (e) {
            console.log('post message error!', e)
          }
        },
        postMessage(func, ...args) {
          let win = document.getElementById('engineIfr').contentWindow
          let data = JSON.stringify({ func, args })
          win.postMessage(data, '*')
        },
      })
    },
    fn_messageListener(e) {
      console.log('--get message from 引擎', e)
      try {
        var { func, args } = JSON.parse(e.data)
        if (!func) return console.warn('$website调用方法参数为空', func)
        let fn = window.$website[func]
        if (!fn)
          return fn === null ? this.showDownloadTip() : console.warn('$website调用方法不存在', func)
        else fn.apply(null, args || [])
      } catch (err) {
        console.warn('$website调用方法失败，错误信息：', err)
      }
    },
    doBuyOption: _.throttle(
      function (optParams) {
        let params = {
          opusId: this.gindex,
          s_id: optParams.s_id,
          i_id: optParams.i_id,
          type: optParams.type,
          num: optParams.num,
          is_auto_buying: 1,
          plat_type: 0,
          channel_type: 0,
        }
        this.$api
          .buyOption(params)
          .then((res) => {
            if (res.isOk) {
              window.$website && window.$website.postMessage('buyOptionCallback', true)
              this.setPageDetail({
                is_auto_buying: params.is_auto_buying,
              })
              this.$toast('开启成功，继续阅读吧')
            } else {
              window.$website && window.$website.postMessage('buyOptionCallback', false)
              this.$toast('开启失败，' + res.message.message)
            }
            //无论购买成功与否，都更新水晶余额
            if (res.data && res.data.crystalNum != undefined) {
              // this.setPageDetail({ // -- 改成更新用户信息中的水晶字段，而弃用详情页数据中的水晶字段
              //   user_crystal_num: res.data.crystalNum*1 || 0
              // })
              this.vx_setUserInfo({
                crystalNum: res.data.crystalNum * 1 || 0,
              })
            }
          })
          .catch((e) => {
            if (this.is_auto_buying)
              window.$website && window.$website.postMessage('buyOptionCallback', false)
            this.$toast('网络连接失败')
            console.error(e)
          })
      },
      2000,
      { trailing: false }
    ),
  },
}
</script>

<style lang="less" scoped>
.DetailCont-container {
  height: calc(100vh - 100px);
  padding-bottom: 60px;
  color: #ccc;
  font-size: 16px;
  overflow: auto;
}

.my-wrap {
  padding: 0 70px;
}

.my-invalid {
  font-size: 32px;
}

.my-right {
  position: relative;
  width: calc(100% - 400px);
  padding-right: 60px;
  padding-bottom: 220px;
}

.my-slogan {
  font-size: 13px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.my-engine {
  // padding-right: 60px;
}
// .my-left{
//   width: 320px;
//   height: 640px;
// }
.engine-wrapper {
  position: relative;

  margin-right: 40px;

  width: 360px;
  height: 680px;
}
.my-engine-ifr {
  // width: 360px;
  // height: 640px;
  width: 400px;
  height: 800px;
  // border: none;
  background: transparent;
  // from doudou 2022-5-25 16:06:29
  transform: scale(0.9);
  transform-origin: 0px 0px 0px;
}

.my-brief,
.my-taglist,
.my-inforow {
  margin-top: 10px;
}

.my-title {
  font-size: 20px;
  em {
    margin-left: 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 1px 5px;
    font-size: 13px;
  }
}

.my-taglist {
  @color: #516486;
  li {
    float: left;
    max-width: 116px;
    margin: 5px 20px 5px 0;
    border: 1px solid @color;
    border-radius: 5px;
    padding: 4px 8px;
    color: @color;
    white-space: nowrap;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.my-brief {
  height: 270px;
  line-height: 30px;
  font-family: inherit;
  white-space: pre-line;
  overflow: auto;
}

.my-qrcodegroup {
  position: absolute;
  bottom: 0;
}

// 广告自定义样式
/deep/ .cg-ad-win {
  font-size: 12px;

  .cg-ad-mute, .cg-close-ad-brief {
    width: 20px;
    height: 20px;
  }

  .cg-ad-close {
    line-height: 20px;
  }

  .cg-ad-toast {
    font-size: 12px !important;
  }
}
</style>
